export default function photoGallery() {
  const modalElement = document.getElementById('pgmodal');
  const modalTargetElements = document.querySelectorAll('[data-pgmodal-target]');
  let splideInstance = null;
  let isOpen = false;

  if (modalElement === null || modalTargetElements.length === 0) return;

  new MutationObserver(() => {
    const isShowNow = modalElement.classList.contains('is-open');

    if (isOpen !== isShowNow) {
      isOpen = isShowNow;
      if (!isOpen) {
        if (splideInstance !== null && splideInstance instanceof Splide) {
          splideInstance.destroy();
          splideInstance = null;
        }
      }
    }
  }).observe(modalElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  const modalEventHandler = (event) => {
    const targetItemElement = (() =>
      event.target.dataset.pgmodalTarget
        ? document.querySelector(`[data-pgmodal-id="${event.target.dataset.pgmodalTarget}"]`)
        : null)();

    event.preventDefault();

    MicroModal.show('pgmodal', {
      awaitCloseAnimation: true,
      disableScroll: true,
      onShow(microModalElement) {
        const splideElement = microModalElement.querySelector('.splide');

        if (splideElement === null) return;

        const itemIndex = (() => {
          if (targetItemElement !== null) {
            const indexNumber = Array.from(
              microModalElement.querySelectorAll('.splide__slide'),
            ).indexOf(targetItemElement);

            return indexNumber === -1 ? 0 : indexNumber;
          }
          return 0;
        })();

        splideInstance = new Splide(splideElement, {
          type: 'fade',
          rewind: true,
          speed: 2500,
          arrows: true,
          pagination: false,
          // autoplay: true,
          // interval: 5000,
          pauseOnHover: false,
          start: itemIndex,
        });
        splideInstance.mount();
      },
    });
  };

  modalTargetElements.forEach((element) => {
    element.addEventListener('click', modalEventHandler);
  });
}
